import { createRoute } from '@tanstack/react-router';
import { Route as parent } from './site.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: 'assets' }).lazy(() =>
  import('./site-assets.lazy.tsx').then((module) => module.Route),
);
